import React from 'react';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { clientDetailsQuery } from '@store/clients/details';

import { Add } from '@icons/index';

import DocumentsTableUnit from '@screens/admin/clients/details/clientUnits/details/documents/Documents.table';

const DocumentsTabUnits = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack flex={1} spacing={2} mt="-35px">
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          {!clientDetailsQuery.isArchived && (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button
                onClick={() => navigate('add')}
                variant="contained" color="primary"
                startIcon={<Add />}>
                {t('clients.details.documents.addButton')}
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>
      <DocumentsTableUnit />
    </Stack>
  );
};

export default DocumentsTabUnits;
